import React, { createContext, useContext, useEffect, useState } from 'react';
import { useInitData } from '@telegram-apps/sdk-react';

const UserContext = createContext();

export const useUser = () => useContext(UserContext);

const UserProvider = ({ children }) => {
    const [userData, setUserData] = useState(null);
    const initData = useInitData();

    console.log(initData);
    
    const apiUrl = process.env.REACT_APP_API_URL
    useEffect(() => {
        const savedUserId = localStorage.getItem('telegram_user_id');
    
        const saveUser = async (userData) => {
            try {
                const response = await fetch(`${apiUrl}api/save-or-authorize-user/`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ user: userData }),  
                });
    
                if (!response.ok) {
                    throw new Error('Failed to save user');
                }
    
                const savedData = await response.json();
                return savedData;
            } catch (error) {
                console.error('Error saving user:', error);
            }
        };
    
        if (!initData || !initData.user) {
            console.error('No user data from Telegram InitData');
            return;
        }
    
        const newUser = {
            telegram_id: initData.user.id,
            username: initData.user.username,
            first_name: initData.user.firstName,
            last_name: initData.user.lastName || '',
            language_code: initData.user.languageCode,
            allows_write_to_pm: initData.user.allowsWriteToPm,
        };
    
        saveUser(newUser).then(() => {
            localStorage.setItem('telegram_user_id', initData.user.id);
            fetch(`${apiUrl}apps/account/?user_id=${initData.user.id}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                }
            })
            .then(response => response.json())
            .then(data => setUserData(data))
            .catch(error => console.error('Error loading user data:', error));
        });
    
    }, [initData]);
    

    return (
        <UserContext.Provider value={userData}>
            {children}
        </UserContext.Provider>
    );
};

export default UserProvider;
